import { VariantProps, tv } from "tailwind-variants"

export type LineClampVariantProps = VariantProps<typeof lineClampVariants>

export const lineClampVariants = tv({
  base: "break-all",
  variants: {
    lines: {
      1: "line-clamp-1",
      2: "line-clamp-2",
      3: "line-clamp-3",
      4: "line-clamp-4",
      5: "line-clamp-5",
      6: "line-clamp-6",
    },
  },
})
